import { render, staticRenderFns } from "./SessionAcceptForm.vue?vue&type=template&id=28f08655&"
import script from "./SessionAcceptForm.vue?vue&type=script&lang=js&"
export * from "./SessionAcceptForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports